[
    {
      "uuid": "b3242a97-9de0-4279-a3f4-42ca71447c35",
      "armDelaySeconds": 3,
      "disarmDelaySeconds": 0,
      "triggerDelaySeconds": 0,
      "timeoutDurationSeconds": 3,
      "capabilities": {
        "arm": "x",
        "partialArm": "x",
        "disarm": "x"
      },
      "state": "disarmed",
      "alarms": [
        {
          "uuid": "040000aa-1398-4ca1-ab44-e071746d6093",
          "name": "",
          "translationKey": "night",
          "capabilities": {
            "arm": "x"
          }
        },
        {
          "uuid": "b44ce89a-6678-4ceb-84ee-bb27fd97368f",
          "name": "",
          "translationKey": "away",
          "capabilities": {
            "arm": "x"
          }
        },
        {
          "uuid": "5663ddc1-25c2-4e80-82a6-d99faa0a559a",
          "name": "",
          "translationKey": "home",
          "capabilities": {
            "arm": "x"
          }
        }
      ],
      "alarmAreas": [
        {
          "uuid": "db2c8ffc-b658-4f53-8436-5932c02441a4",
          "name": "",
          "translationKey": "floor_lvl_0",
          "sensorGroups": [
            {
              "uuid": "4612c489-5949-4bc7-a3f1-9e005abb1875",
              "name": "",
              "translationKey": "room_living_room",
              "sensors": [
                {
                  "uuid": "c98d845b-95fa-4cf2-86d2-v66bef6358f8",
                  "name": "",
                  "translationKey": "window",
                  "state": "closed"
                },
                {
                  "uuid": "e7a8d774-3635-40a0-924d-1da9bf6f8200",
                  "name": "",
                  "translationKey": "motion_sensor",
                  "state": "idle"
                }
              ]
            }
          ],
          "sensors": [
            {
              "uuid": "3dc1c58ac-3635-40a0-924d-1da9bf6f8200",
              "name": "",
              "translationKey": "motion_sensor",
              "state": "idle"
            }
          ]
        },
        {
          "uuid": "9e6a7a0b-6f64-4d39-a1b1-53a2cb7d87af",
          "name": "",
          "translationKey": "room_garden",
          "sensorGroups": [
            {
              "uuid": "4612c489-4444-4bc7-a3f1-9e005abb1875",
              "name": "",
              "translationKey": "room_garden",
              "sensors": [
                {
                  "uuid": "b4f09a03-4c17-4c26-ae0e-5c53c6b67f0f",
                  "name": "",
                  "translationKey": "door",
                  "state": "closed"
                },
                {
                  "uuid": "7b1b2d14-66b5-4b4c-b7a8-2af42b8a7a5b",
                  "name": "",
                  "translationKey": "motion_sensor",
                  "state": "idle"
                }
              ]
            },
            {
              "uuid": "57d87e46-214a-48b9-9d4e-0bacd8c63e92",
              "name": "",
              "translationKey": "room_stable",
              "sensors": [
                {
                  "uuid": "ef6d0953-b377-4ae0-bcf3-bb8c8e5d35be",
                  "name": "",
                  "translationKey": "door",
                  "state": "closed"
                },
                {
                  "uuid": "13335ab4-4098-448e-87ce-aa72358246c3",
                  "name": "",
                  "translationKey": "gate",
                  "state": "closed"
                }
              ]
            }
          ]
        },
        {
          "uuid": "e9233cf2-8b89-4b52-bd29-67a839f93e7b",
          "name": "",
          "translationKey": "room_garage",
          "sensorGroups": [
            {
              "uuid": "4612c489-2222-4bc7-a3f1-9e005abb1875",
              "name": "",
              "translationKey": "room_garage",
              "sensors": [
                {
                  "uuid": "e9233cf2-8b89-4b52-bd29-67a839f93e7b",
                  "name": "",
                  "translationKey": "gate",
                  "state": "closed"
                },
                {
                  "uuid": "09e3d7a2-6b16-4f1a-b48a-836b4a4a915b",
                  "name": "1",
                  "translationKey": "window",
                  "state": "closed"
                },
                {
                  "uuid": "a52e3e1f-21fb-4b8c-8d2d-b037932dbd0c",
                  "name": "2",
                  "translationKey": "window",
                  "state": "closed"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
